import axios from "axios";
import axi from "./axiConfig";
import store from "../store/index";
import router from "../router";
import {refreshWorkspaceAccess} from "@/utils/brokerWorkspaces";
import {notifyWorkspaceLogout} from "@/utils/workspaceExternalNavigation";

const baseURL = process.env.NODE_ENV !== "production" ?
  "https://api.bankari.sk/api" :
  "https://api.bankari.sk/api";

// const baseURL = "https://api.bankari.sk/api";

const api = axios.create({
  baseURL,
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => {
    if (response.config.url === "user/me/") {
      store.commit("userState/setMe", response.data)
      store.commit("userState/setLogged", {logged: true});
    } else if (response.config.url === "auth/logout/") {
      store.commit("userState/setLogged", {logged: false});
      store.commit("userState/setMe", null);
    }

    return response;
  },
  async (error) => {
    if (error.response?.status === 401 && error.config) {
      const config = error.config;
      const endSession = () => {
        store.commit("userState/setLogged", {logged: false});
        store.commit("userState/setMe", null);
        if (!notifyWorkspaceLogout()) router.replace({name: "Landing"}).catch(() => {});
      };
      if (config._workspaceRetried || /auth\/(?:token|logout|login)/.test(config.url || '')) {
        endSession();
        return Promise.reject(error);
      }
      config._workspaceRetried = true;
      try {
        const payload = await refreshWorkspaceAccess(() => axi.post("auth/token/refresh/").then(response => response.data));
        const user = payload.user || store.getters["userState/getMe"];
        if (!["alex_admin", "financnik", "znalec"].includes(user?.role)) throw error;
        const current = store.getters["userState/getMe"];
        if (current && (String(current.id) !== String(user.id) || current.role !== user.role)) throw error;
      } catch (refreshError) {
        endSession();
        return Promise.reject(refreshError);
      }
      return api.request(config);
    }

    return Promise.reject(error);
  }
);

export default api;
